import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[HTMLTranslate]',
    standalone: false
})
export class HTMLTranslateDirective implements OnInit, OnDestroy {
  @Input('HTMLTranslate') translateKey: string;
  translateKeyAttribute: string = '';
  private translationSub?: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.setTranslateKey();
    if (this.translateKeyAttribute) {
      // Imposta l'attributo translate-key
      this.renderer.setAttribute(
        this.el.nativeElement,
        'translate-key',
        this.translateKeyAttribute
      );

      // Ottieni la traduzione
      this.translationSub = this.translateService
        .stream(this.translateKeyAttribute)
        .subscribe((translatedValue: string) => {
          // Imposta il testo tradotto e aggiorna al cambio lingua
          this.renderer.setProperty(
            this.el.nativeElement,
            'innerHTML',
            translatedValue
          );
        });
    }
  }

  ngOnDestroy(): void {
    this.translationSub?.unsubscribe();
  }

  setTranslateKey(): string {
    this.translateKeyAttribute = this.translateKey;
    if (!this.translateKeyAttribute) {
      this.translateKeyAttribute = this.el.nativeElement.textContent.trim();
    }

    if (this.translateKeyAttribute) {
      this.el.nativeElement.setAttribute(
        'translate-key',
        this.translateKeyAttribute
      );
    }
    return this.translateKeyAttribute;
  }
}
